import { VersionCheckModal } from '@/components/VersionCheckModal';
import { App, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import type { ReactNode } from 'react';
import { Toaster } from 'sonner';
import { FeatureConfigProvider } from '@/components/FeatureConfigProvider';
dayjs.locale('zh-cn');

const theme = {
    // cssVar: true,
    token: {
        colorPrimary: '#0670b9',
    },
}



interface AppProviderProps {
    children: ReactNode
}

export const AppProvider = ({ children }: AppProviderProps) => {
    return <ConfigProvider theme={theme} locale={zhCN} prefixCls="gs-v2-ant">
        <App>
            <FeatureConfigProvider>
                {children}
                <Toaster position="top-center" closeButton richColors />
                {
                    process.env.NODE_ENV != 'development' && <VersionCheckModal />
                }
            </FeatureConfigProvider>

        </App>
    </ConfigProvider>
}
